// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ahG4Je1","label":"LGDJAvCI","count":"_1dnTDz88"};